import util from '@bmp-vue/core/api/util'

const controller = 'Kraken'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  EnviarArquivoExcelFipe: function (dto) {
    return util.Axios.PostForm(controller + '/EnviarArquivoExcelFipe', dto)
  },
  GetAllGravames: function () {
    return util.Axios.GetAll(controller + '/GetAllGravames', {})
  },
  InserirOuAtualizarGravame: function (dto) {
    return util.Axios.Post(controller + '/InserirOuAtualizarGravame', dto)
  },
  GetStatusProcessamentoArquivoExcelRecentes: function () {
    return util.Axios.GetAll(controller + '/GetStatusProcessamentoArquivoExcelRecentes', {})
  },
  GetStatusProcessamentoArquivo: function (dto) {
    return util.Axios.Get(controller + '/GetStatusProcessamentoArquivo', dto)
  },
  tipoVeiculo (tipoVeiculo) {
    return tipoVeiculo === 1 ? 'Carro' : tipoVeiculo === 2 ? 'Moto' : 'Caminhão'
  }
})
